//===================================================
// 1.Load,Init,Settings
//===================================================
import React from "react";
import { useNavigate } from "react-router-dom";
// Material-ui
import { Container } from "@mui/material";

// custom components
import { UserDetails } from "../../molecules/";

// css *required
import { useStyles } from "./index.css";

//===================================================
// 2.Main Component
//===================================================
const Profile = (props) => {
  // 2-1. useStyles *require
  const classes = useStyles();
  const navigate = useNavigate();
  // 2-2. Store

  // showMain
  return showMain({
    ...props,
    classes,
    navigate,
  });
};

//===================================================
// 3.Export
//===================================================
export default Profile;

//===================================================
// 4.propTypes and defaultProps
//===================================================

//4-1. propTypes
Profile.propTypes = {};

//4-2. defaultProps
Profile.defaultProps = {};

//===================================================
// 5.Functions *require showMain()
//===================================================
/**
 * Show main
 * @param {*} props
 */
const showMain = (props) => {
  const { classes } = props;
  return (
    <>
      <Container className={classes.fullWith} maxWidth={false}>
        <UserDetails />
      </Container>
    </>
  );
};

//===================================================
// 6.Actions
//===================================================